export default __webpack_public_path__ + "5c06d96462f9d1812b88af8fc4700447.png";